import React from 'react';
import { useAudio } from '../../contexts/AudioContext';
import Icon from '../AppIcon';

const AudioPlayer = () => {
  const { playing, muted, toggleMute, loaded } = useAudio();

  if (!loaded) {
    return null; // Don't show player if no audio loaded
  }

  return (
    <div className="fixed bottom-24 right-4 z-50">
      <button
        onClick={toggleMute}
        className="w-14 h-14 rounded-full bg-card border border-border shadow-romantic-lg flex items-center justify-center transition-romantic hover-lift press-scale"
        aria-label={muted ? 'Unmute music' : 'Mute music'}
      >
        <Icon
          name={muted ? 'VolumeX' : 'Volume2'}
          size={24}
          color="var(--color-primary)"
          className={!muted && playing ? 'animate-pulse' : ''}
        />
      </button>
    </div>
  );
};

export default AudioPlayer;
